import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { EmployeeSliceState } from "../../utils/employee.types";
import { ApiStatus } from "../../utils/api.types";
import { addEmployee, deleteEmployee, fetchEmployees, updateEmployee, deleteEmpAttachment, fetchEmployeeById, fetchEmployeeByAccountId } from "./employeeThunk";

/**
 * Invoice slice initial state.
 */
const initialState: EmployeeSliceState = {
    employees: [],
    employeeDetails: {},
    rowCount: 0,
    errorMessage: '',
    isEmployeeCreated: false,
    selectedEmployeeId: '',
    status: ApiStatus.IDLE
}

/**
 * Inventory Slice.
 */
const inventorySlice = createSlice({
    name: 'inventory',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch Employees
            .addCase(fetchEmployees.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchEmployees.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.employees = action?.payload.employees || [];
                state.rowCount = action?.payload.total || 0;
                state.errorMessage = '';
            })

            .addCase(fetchEmployees.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Employee by Account ID
            .addCase(fetchEmployeeByAccountId.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchEmployeeByAccountId.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.employees = action?.payload?.inventories || [];
                state.errorMessage = '';
            })
            .addCase(fetchEmployeeByAccountId.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Inventory by ID
            .addCase(fetchEmployeeById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchEmployeeById.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.employeeDetails = action?.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchEmployeeById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add Inventory
            .addCase(addEmployee.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addEmployee.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.isEmployeeCreated = true;
                state.employees.push(action.payload.invoice);
                state.errorMessage = '';

                toast.success(action.payload.message);
            })
            .addCase(addEmployee.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.isEmployeeCreated = false;
                state.errorMessage = action.error.message
            })

            // Delete Employee
            .addCase(deleteEmployee.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteEmployee.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';

                const { id, message } = action.payload;
                state.employees = state.employees.filter(item => item._id !== id)

                toast.success(message);
            })
            .addCase(deleteEmployee.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message

                toast.success(state.errorMessage);
            })

            // Update Employee
            .addCase(updateEmployee.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateEmployee.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message: message, employee: updatedEmployee } = action.payload
                state.employeeDetails = updatedEmployee;
                state.errorMessage = '';
                toast.success(message);
            })
            .addCase(updateEmployee.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
            })

            // Update Employee for deleteEmpAttachment
            .addCase(deleteEmpAttachment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteEmpAttachment.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message: message, employee: updatedEmployee } = action.payload
                state.employeeDetails = updatedEmployee;
                state.errorMessage = '';
                toast.success(message);
            })
            .addCase(deleteEmpAttachment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })
    }
});

export default inventorySlice.reducer;
